import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import MoneyRendererV3 from '../../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import Typography from '../../../../components/Typography/Typography';
import { ReducedProductPricesV2Props } from '../interfaces/productPricesV2.interfaces';
import { useReducedProductPricesV2Styles } from '../styles/reducedProductPricesV2.styles';

const ReducedProductPricesV2 = ({ priceCompositions }: ReducedProductPricesV2Props) => {
  const { classes } = useReducedProductPricesV2Styles();

  return (
    <TableContainer className={classes.root}>
      <Table size="small">
        <TableBody>
          {priceCompositions.map((composition, index) => (
            <TableRow
              key={`${composition.label}-${index}`}
              className={index === priceCompositions.length - 1 ? classes.lastRow : ''}
            >
              <TableCell align="left" style={{ paddingRight: 16 }}>
                <Typography variant="body2.5-regular" color="textSecondary" align="left">
                  {composition.label}
                </Typography>
              </TableCell>
              <TableCell>
                <MoneyRendererV3
                  value={Number(composition.price)}
                  size="small"
                  horizontalAlign="right"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReducedProductPricesV2;
